/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TaskAddedIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TaskAddedIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TaskAddedIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TaskAddedIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-1MIDSs': alignSelf,'--mt-2-1MIDSs': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1MIDSs': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1MIDSs': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1MIDSs': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1MIDSs': opacity,'--w-10-1MIDSs': typeof width === 'number' ? `${width}px` : width,'--h-11-1MIDSs': typeof height === 'number' ? `${height}px` : height,'--f-12-1MIDSs': fill,'--a-7-1MIDSs': isAnimated ? animation : "none",'--sd-8-1MIDSs': isAnimated ? strokeDashoffset : 0,'--sd-9-1MIDSs': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TaskAddedIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.25 0a.75.75 0 000 1.5h7.5a.75.75 0 01.75.75v7.5a.75.75 0 001.5 0v-7.5A2.25 2.25 0 0011.75 0h-7.5zM9.5 3A1.5 1.5 0 0111 4.5v8A1.5 1.5 0 019.5 14h-8A1.5 1.5 0 010 12.5v-8A1.5 1.5 0 011.5 3h8zM2.25 8.5A.75.75 0 013 7.75h1.75V6a.75.75 0 011.5 0v1.75H8a.75.75 0 010 1.5H6.25V11a.75.75 0 01-1.5 0V9.25H3a.75.75 0 01-.75-.75z"
 style={{'--f-12-1MIDSs': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}